import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { FAQ_CATEGORIES } from "@/data/site";

const FaqSection = () => (
  <section className="py-24 md:py-32 bg-cream" data-testid="faq-section">
    <div className="max-w-[1100px] mx-auto px-6 md:px-12">
      <Reveal>
        <Eyebrow>Common Questions</Eyebrow>
        <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-navy text-balance">
          Guidance for the <em className="italic text-gold-hover">diaspora.</em>
        </h2>
        <p className="text-muted-foreground mt-6 text-base md:text-lg max-w-xl leading-relaxed">
          Answers to the questions we hear most often from clients managing
          Jamaican matters from overseas.
        </p>
      </Reveal>

      {FAQ_CATEGORIES.map((category, ci) => (
        <Reveal key={category.title} delay={0.05} className="mt-14 md:mt-16">
          <div className="flex items-baseline gap-4 border-b-2 border-gold/60 pb-4">
            <span className="font-serif italic text-gold-hover text-2xl">{category.number}.</span>
            <h3 className="font-serif text-2xl md:text-3xl text-navy font-light">{category.title}</h3>
          </div>
          <Accordion type="single" collapsible>
            {category.items.map((item, ii) => (
              <AccordionItem
                key={ii}
                value={`${ci}-${ii}`}
                className="border-b border-navy/10"
                data-testid={`faq-item-${ci}-${ii}`}
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${ci}-${ii}`}
                  className="py-6 text-left font-sans font-semibold text-navy text-base md:text-lg hover:text-gold-hover hover:no-underline [&[data-state=open]>svg]:text-gold-hover"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-sm md:text-base max-w-3xl">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      ))}
    </div>
  </section>
);

export default FaqSection;
